import React, { useEffect, useState } from "react";
import api, { money } from "@/lib/api";
import AdminLayout from "@/pages/admin/AdminLayout";

export default function AdminCustomers() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/admin/customers").then(({ data }) => setRows(data)); }, []);

  return (
    <AdminLayout title="Customers">
      <div className="overflow-x-auto bg-card border border-border rounded-lg">
        <table className="w-full text-sm">
          <thead className="bg-muted text-left"><tr>
            <th className="p-3">Name</th><th className="p-3">Email</th><th className="p-3">Phone</th><th className="p-3 text-right">Orders</th><th className="p-3 text-right">RicePoints</th>
          </tr></thead>
          <tbody>
            {rows.map((c) => (
              <tr key={c.user_id} className="border-t border-border" data-testid={`customer-${c.user_id}`}>
                <td className="p-3 font-semibold">{c.name}</td>
                <td className="p-3 text-muted-foreground">{c.email}</td>
                <td className="p-3 text-muted-foreground">{c.phone || "—"}</td>
                <td className="p-3 text-right font-mono-points">{c.orders_count}</td>
                <td className="p-3 text-right font-mono-points font-semibold text-primary">{money(c.ricepoints_balance)}</td>
              </tr>
            ))}
            {rows.length === 0 && <tr><td colSpan={5} className="p-8 text-center text-muted-foreground">No customers.</td></tr>}
          </tbody>
        </table>
      </div>
    </AdminLayout>
  );
}
